import clsx from 'clsx';
import { Controller, useFormContext } from 'react-hook-form';
import ImageUploader from '../../ImageUploader/ImageUploader';
import { AdFormSchema } from '../AdForm/AdFormTypes';

interface WrapperImageProps {
  defaultImage?: string;
  width?: number;
  height?: number;
  name: keyof AdFormSchema['wrapperDetails'];
}

const WrapperFormImage = ({ defaultImage, width, height, name }: WrapperImageProps) => {
  const {
    control,
    clearErrors,
    setError,
    formState: { errors },
  } = useFormContext<AdFormSchema>();

  return (
    <div
      className={clsx(
        'bg-white rounded-md h-fit p-4',
        errors.wrapperDetails?.[name]?.message && 'border-error'
      )}
      data-testid="image-input"
    >
      {/* <h2 className="text-lg font-semibold">{t('form.ad-image')}</h2> */}
      <Controller
        control={control}
        name={`wrapperDetails.${name}`}
        rules={{ required: 'Ad image is required.' }}
        render={({ field: { onChange } }) => (
          <ImageUploader
            subText="or drop an image to upload"
            criteria={`Image size ${width} x ${height} px (.jpg .png or .webp). Maximum 5MB.`}
            widthReq={width ?? 900}
            heightReq={height ?? 750}
            defaultImg={defaultImage || ''}
            imageUrlCB={onChange}
            setErrorAdvert={error => setError(`wrapperDetails.${name}`, error)}
            clearErrorsAdvert={clearErrors}
            imgType="WRAPPER_IMAGE"
            formError={errors.wrapperDetails?.[name]?.message ?? ''}
          />
        )}
      />
    </div>
  );
};

export default WrapperFormImage;
